var _effectorFileName = "/src/shared/components/icons/search-icon.tsx";
import React, { SVGProps } from 'react';
export const SearchIcon = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <path fill="currentColor" d="M8.5 3a5.5 5.5 0 0 1 4.383 8.823l4.147 4.147a.75.75 0 0 1-.976 1.133l-.084-.073l-4.147-4.147A5.5 5.5 0 1 1 8.5 3m0 1.5a4 4 0 1 0 0 8a4 4 0 0 0 0-8"></path>
    </svg>;
};
const MemoSearchIcon = React.memo(SearchIcon);
export default MemoSearchIcon;